import React, {useRef} from 'react';
import DataLoader from "../../components/loader/dataLoader";
import Tinymce from "../../components/tinymce";
import useAbout from "../../hooks/admin/useAbout";
import {toast} from "react-toastify";

const Index = () => {
  const editorRef = useRef(null);
  const {data, isLoading, error, update} = useAbout();
  const {id, description} = data;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (editorRef.current.getContent().toString().trim() < 10) {
      toast.error('Min Length 10 Characters');
      return;
    }
    update({description: editorRef.current.getContent()}, id);
  }

  if (error) return null;
  return (
      <section id='about' className='about'>
        <div className='custom-container'>
          <div className='content-section'>
            <h1 className='page-title'>About Us</h1>
            <div className='content-body'>
              {isLoading ?
                  <DataLoader/> :
                  <>
                    <h2 className='content___body-title mb-4'>Customs Bond Commissionerate (CBC)</h2>
                    <form onSubmit={handleSubmit}>
                      <Tinymce
                          editorRef={editorRef}
                          value={description}
                      />
                      <div className='text-right mt-4 mb-3'>
                        <button type='submit' className='save-btn'>Save</button>
                      </div>
                    </form>
                  </>
              }
            </div>
          </div>
        </div>
      </section>
  )
      ;
};

export default Index;
